var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationTag = function SvgSimpleIllustrationTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__tag_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__tag_svg__st2{fill:#ffed8f}.simple-illustration__tag_svg__st3{fill:none;stroke:#002140;stroke-width:.8563;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M30.437 20.394 19.721 17.41l-8.508 9.724 4.529 10.716 26.074 22.87 15.138-16.683-26.517-23.643zm-8.951 9.987a2.983 2.983 0 1 1-.001-5.967 2.983 2.983 0 0 1 .001 5.967z",
    style: {
      fill: "#ffd7b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.319 44.595-3.317-2.874-9.72 10.939 3.203 2.651 9.834-10.716z",
    style: {
      fill: "#e4bc07"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.225 20.984s-1.988.443-2.211 1.399c-.223.956 1.585 3.53 3.61 4.642 2.025 1.109 4.272 1.842 5.155.809.882-1.032-.296-3.42-.296-3.42s-1.692 2.314-3.976.546-2.284-2.651-1.768-3.167c.516-.516-.516-.809-.516-.809h.002z",
    className: "simple-illustration__tag_svg__st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.961 21.499 2.431-2.597s-.882-8.342 6.354-8.452c4.915-.11 11.382 4.585 16.85 4.529 5.468-.057 6.187-.996 6.187-.996s.606-2.098-.606-2.098-2.321.883-5.028.496c-2.707-.386-13.48-4.199-16.297-4.252-2.818-.054-10.553.333-9.891 13.37z",
    className: "simple-illustration__tag_svg__st2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.495 22.195 4.489-5.022 10.383 3.307 26.357 23.57-14.928 16.69-26.354-23.57L11 27.22l2.454-2.74",
    className: "simple-illustration__tag_svg__st3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.282 25.464a2.875 2.875 0 1 1-.633 2.67M48.035 41.33l-9.877 11.043 3.294 2.946 9.877-11.043-3.294-2.946zM26.997 42.811l5.671-6.34M29.635 45.168l5.671-6.34",
    className: "simple-illustration__tag_svg__st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.463 24.6c.749 1.039.996 2.071.553 2.774-.769 1.222-3.333.992-5.721-.513-2.391-1.505-3.706-3.716-2.934-4.938.47-.749 1.612-.952 2.977-.653",
    className: "simple-illustration__tag_svg__st3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.917 25.122c-.49.776-2.081.649-3.556-.28s-2.274-2.311-1.788-3.087M15.852 21.279s-1.988-10.716 6.52-12.927c8.508-2.211 16.683 6.85 24.859 3.313",
    className: "simple-illustration__tag_svg__st3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.373 18.976c-.423-2.394.333-7.739 5.997-8.465 5.661-.726 14.905 6.953 23.47 3.583",
    className: "simple-illustration__tag_svg__st3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.84 14.097s1.049-1.602-.606-2.431",
    className: "simple-illustration__tag_svg__st3"
  })));
};
export default SvgSimpleIllustrationTag;